import { AfterViewInit, Component, Input, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { VoucherLetter } from 'app/models/vouchers/voucher-letter';
import { VoucherLetterUpload } from 'app/models/vouchers/voucher-letter-upload';
import { VoucherService } from 'app/services/voucher-service';
import { ToastrService } from 'ngx-toastr';
import { AttachLetterComponent } from './attach/attach-letter.component';
import { SendLetterComponent } from './send/send-letter.component';
import { LubgwmaTestingVoucherLetterComponent } from './voucher/lubgwma/lubgwma-testing-voucher-letter.component';
import { LubgwmaTreatmentVoucherLetterComponent } from './voucher/lubgwma/lubgwma-treatment-voucher-letter.component';
import { SharedService } from '@shared/services/shared.service';
import { NotEligibleVoucherLetterComponent } from './voucher/not-eligible/not-eligible-voucher-letter.component';
import { COCVoucherLetterComponent } from './voucher/chain-of-custody/coc-voucher-letter.component';
import { OregonWellDataService } from 'app/services/oregon-well-data.service';
import { AuthService } from '@shared/auth/auth.service';

@Component({
  selector: 'voucher-letters',
  templateUrl: './voucher-letters.component.html',
  styleUrls: ['./voucher-letters.component.scss']
})
export class VoucherLettersComponent implements AfterViewInit {
  @Input('voucherId')
  voucherId: number = 0;
  @Input('applicationId')
  applicationId: number = 0;
  processing: boolean = false;
  loading: boolean = false;
  displayedColumns: string[] = ['letterType', 'complete', 'sampleId', 'analyte', 'result', 'sentDate', 'actions'];
  dataSource = new MatTableDataSource<VoucherLetter>();
  @ViewChild('TablePaginator') paginator: MatPaginator;
  @ViewChild('TableSort') sort: MatSort;
  pageSize = 10;
  resultSize: number = 0;
  voucherIdForLetter: number = 0;
  parameterResultIdForLetter: number = 0;
  downloading: boolean = false;
  attachment: VoucherLetterUpload = undefined;
  letters: VoucherLetter[] = [];
  cocGenerated: boolean = false;

  filterTable(event: Event) {
    let value = (event.target as HTMLInputElement).value;
    this.dataSource.filter = value.trim().toLowerCase();
  }

  constructor(public dialog: MatDialog,
    public voucherService: VoucherService,
    public oregonWellDataService: OregonWellDataService,
    public authService: AuthService,
    private toastr: ToastrService,
    private sharedService: SharedService) {
    this.loading = true;
  }

  load() {

    if(this.voucherId > 0) {
      this.loadVoucherLetters();
    }
    else if(this.applicationId > 0) {
      this.loadApplicationLetters();
    }
    else {
      this.toastr.error("Invalid Letter operation.")
    }
  }

  generateCOC() {
    
    const generateLetter: VoucherLetterUpload = {
      id: 0,
      letterHtml: '',
      letterType: this.voucherService.voucherCOCLetterType,
      parameterResultId: 0,
      sampleId: 0,
      voucherId: this.voucherId,
      letterContent: '',
      voucherApplicationId: this.applicationId,
      quarter: 0,
      year: 0,
      tier: 0,
      testType: '',
      testsRequired: '',
      retestId: 0,
      wellAddress: '',
      customerName: '',
      mailingAddress: '',
      mailingCity: '',
      mailingState: '',
      mailingZip: '',
      phone: '',
      email: '',
      voucherIdentifier: '',
      base64File: ''
    }
      const dialogRef = this.dialog.open(COCVoucherLetterComponent, {
        width: '90%',
        data: generateLetter,
      });
      dialogRef.afterClosed().subscribe(result => {
        this.loadVoucherLetters();
      });
  }

  generate(type: string, parameterResultId: number, sampleId: number, letterId: number, applicationType: string) {
    this.parameterResultIdForLetter = 0;
    this.voucherIdForLetter = 0;

    const generateLetter: VoucherLetterUpload = {
      id: letterId,
      letterHtml: '',
      letterType: type,
      parameterResultId: parameterResultId,
      sampleId: sampleId,
      voucherId: this.voucherId,
      letterContent: '',
      voucherApplicationId: 0,
      quarter: 0,
      year: 0,
      tier: 0,
      testType: '',
      testsRequired: '',
      retestId: 0,
      wellAddress: '',
      customerName: '',
      mailingAddress: '',
      mailingCity: '',
      mailingState: '',
      mailingZip: '',
      phone: '',
      email: '',
      voucherIdentifier: '',
      base64File: ''
    }

    if (applicationType == this.voucherService.lubgwmaTestingVoucherType) {
      if (type == this.voucherService.voucherLetterType ||
          type == this.voucherService.voucherSelfSampleLetterType ||
          type == this.voucherService.voucherScheduleLetterType) {
        const dialogRef = this.dialog.open(LubgwmaTestingVoucherLetterComponent, {
          width: '90%',
          data: generateLetter,
        });
        dialogRef.afterClosed().subscribe(result => {
          this.loadVoucherLetters();
        });
      }
      else if(type == this.voucherService.lubgwmaTreatmentLetterType){
        if(parameterResultId != null && parameterResultId > 0){
          const dialogRef = this.dialog.open(LubgwmaTreatmentVoucherLetterComponent, {
            width: '90%',
            data: generateLetter,
          });
          dialogRef.afterClosed().subscribe(result => {
            this.loadVoucherLetters();
          });
        }
      }
      else {
        this.toastr.error("Unsupported Letter Type");
      }
    }
    else {
      this.toastr.error("Unsuppored Letter/Application Type");
    }
  }

  generateNotEligible(letterType: string, applicationId: number, applicationType: string) {
    const generateLetter: VoucherLetterUpload = {
      id: 0,
      letterHtml: '',
      letterType: letterType,
      parameterResultId: 0,
      sampleId: 0,
      voucherId: 0,
      letterContent: '',
      voucherApplicationId: applicationId,
      quarter: 0,
      year: 0,
      tier: 0,
      testType: '',
      testsRequired: '',
      retestId: 0,
      wellAddress: '',
      customerName: '',
      mailingAddress: '',
      mailingCity: '',
      mailingState: '',
      mailingZip: '',
      phone: '',
      email: '',
      voucherIdentifier: '',
      base64File: ''
    }

    if(applicationType == this.voucherService.lubgwmaTestingVoucherType)
    {
      if(letterType == this.voucherService.notEligible){
        const dialogRef = this.dialog.open(NotEligibleVoucherLetterComponent, {
          width: '90%',
          data: generateLetter,
        });
        dialogRef.afterClosed().subscribe(result => {
          this.loadApplicationLetters();
        });
      }
      else {        
        this.toastr.error("Unknown Letter Type.  Unable to generate.");
      }
    }
    else {
      this.toastr.error("Unknown Application Type.  Unable to generate.");
    }
  }

  ngAfterViewInit(): void {
    this.load();
  }



  loadApplicationLetters() {
    this.loading = true;
    this.voucherService.getVoucherApplicationLetters(this.applicationId).subscribe(
      result => {
        this.letters = result;
        this.dataSource = new MatTableDataSource<VoucherLetter>(result);
        this.resultSize = result.length;
        this.loading = false;
      },
      error => {
        this.loading = false;
      },
      () => {
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      }
    );
  }

  loadVoucherLetters() {
    this.loading = true;
    this.voucherService.getVoucherLetters(this.voucherId).subscribe(
      result => {
        this.letters = result;
        if(this.letters.filter(l => l.letterType == this.voucherService.voucherCOCLetterType).length > 0){
         this.cocGenerated = true;
        }
        else {
          this.cocGenerated = false;
        }
        this.dataSource = new MatTableDataSource<VoucherLetter>(result);
        this.resultSize = result.length;
        this.loading = false;
      },
      error => {
        this.loading = false;
      },
      () => {
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      }
    );
  }

  downloadVoucherLetter(id: number, identifier: string, letterType: string, parameterResultId: number) {
    let fileName = identifier + "-" + letterType;
    if (parameterResultId > 0) {
      fileName = fileName + "-" + parameterResultId;
    }
    this.downloading = true;
    this.voucherService.downloadVoucherLetter(id).subscribe(
      (response) => {
        this.sharedService.downloadFile(fileName, response)
        this.downloading = false;
      },
      (error) => {
        console.log("error", error);
        this.downloading = false;
      }
    );
  }

  downloadApplicationLetter(id: number, letterType: string) {
    let fileName = letterType;
    this.downloading = true;
    this.voucherService.downloadApplicationLetter(id).subscribe(
      (response) => {
        this.sharedService.downloadFile(fileName, response)
        this.downloading = false;
      },
      (error) => {
        console.log("error", error);
        this.downloading = false;
      }
    );
  }

  sendLetter(id: number) {
    let letter = this.letters.find(l => l.id == id);
    const dialogRef = this.dialog.open(SendLetterComponent, {
      width: '70%',
      data: letter,
    });
    dialogRef.afterClosed().subscribe(result => {
      this.load();
    });
  }

  attachVoucherLetter(id: number, voucherId: number, type: string, sampleId: number, parameterResultId: number) {
    if (voucherId == 0) {
      voucherId = this.voucherId
    }

    this.attachment = {
      id: id,
      voucherId: voucherId,
      letterHtml: '',
      letterType: type,
      parameterResultId: parameterResultId,
      sampleId: sampleId,
      letterContent: '',
      voucherApplicationId: 0,
      quarter: 0,
      year: 0,
      tier: 0,
      testType: '',
      testsRequired: '',
      retestId: 0,
      wellAddress: '',
      customerName: '',
      mailingAddress: '',
      mailingCity: '',
      mailingState: '',
      mailingZip: '',
      phone: '',
      email: '',
      voucherIdentifier: '',
      base64File: ''
    }
    const dialogRef = this.dialog.open(AttachLetterComponent, {
      width: '70%',
      data: this.attachment,
    });
    dialogRef.afterClosed().subscribe(result => {
      this.loadVoucherLetters();
    });
  }

  attachApplicationLetter(applicaitonId: number, letterType: string) {
    if (applicaitonId == 0) {
      applicaitonId = this.applicationId
    }

    this.attachment = {
      id: 0,
      voucherId: 0,
      letterHtml: '',
      letterType: letterType,
      parameterResultId: 0,
      sampleId: 0,
      letterContent: '',
      voucherApplicationId: applicaitonId,
      quarter: 0,
      year: 0,
      tier: 0,
      testType: '',
      testsRequired: '',
      retestId: 0,
      wellAddress: '',
      customerName: '',
      mailingAddress: '',
      mailingCity: '',
      mailingState: '',
      mailingZip: '',
      phone: '',
      email: '',
      voucherIdentifier: '',
      base64File  : ''
    }
    const dialogRef = this.dialog.open(AttachLetterComponent, {
      width: '70%',
      data: this.attachment,
    });
    dialogRef.afterClosed().subscribe(result => {
      this.loadApplicationLetters();
    });
  }

  deleteVoucherLetter(id: number) {
    this.sharedService.openConfirm("Are you sure you want to remove this voucher letter?");
    this.sharedService.confirmed().subscribe(confirmed => {
      if (confirmed) {
        this.processing = true;
        this.voucherService.deleteVoucherLetter(id).subscribe(
          result => {
            this.toastr.success("Letter Removed");
            this.loadVoucherLetters();
            this.processing = false;
          },
          error => {
            this.toastr.error("Unable to remove letter");
            this.processing = false;
          }
        );
      }
    });
  }

  deleteApplicationLetter(id: number) {
    this.sharedService.openConfirm("Are you sure you want to remove this application letter?");
    this.sharedService.confirmed().subscribe(confirmed => {
      if (confirmed) {
        this.processing = true;
        this.voucherService.deleteVoucherApplicationLetter(id).subscribe(
          result => {
            this.toastr.success("Letter Removed");
            this.loadApplicationLetters();
            this.processing = false;
          },
          error => {
            this.toastr.error("Unable to remove letter");
            this.processing = false;
          }
        );
      }
    });
  }
}